module.exports = __webpack_public_path__ + "static/media/logo_texto_cinza.413346d8.png";